module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/2cd3e62c68b5bfca3e70a2cd2d108e9b.svg";